module.exports = __webpack_public_path__ + "static/media/Kit_Surg-AoN2.06fc097e.png";